import { render } from "./AppTopBar.vue?vue&type=template&id=9b3f0b24&scoped=true"
const script = {}

import "./AppTopBar.vue?vue&type=style&index=0&id=9b3f0b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3f0b24"]])

export default __exports__